import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-social-media-widgets',
    templateUrl: './social-media-widgets.component.html',
    styleUrls: ['./social-media-widgets.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SocialMediaWidgetsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
